"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowGradeAndFeedback = void 0;
var _react = require("react");
var _hooks = require("../../../../../../../hooks");
var _Select = require("../../../../../../../UI/Select");
var _TaskManager = require("../../../../../TaskManager.provider");
var _SectionLabel = require("../../../SectionLabel");
var _SectionDescription = require("../../../SectionDescription");
var _ShowGradeAndFeedback = _interopRequireDefault(require("./ShowGradeAndFeedback.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ShowGradeAndFeedback = function ShowGradeAndFeedback(props) {
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    task = _useContext.task,
    setTask = _useContext.setTask,
    setIsChanged = _useContext.setIsChanged,
    getLabel = _useContext.getLabel;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var styles = (0, _ShowGradeAndFeedback.default)();
  var showGradeOptions = [{
    value: true,
    label: getLabel('show_mark_false')
  }, {
    value: false,
    label: getLabel('show_mark_true')
  }];
  var _useState = (0, _react.useState)({
      value: task.hideGrade,
      label: getLabel("show_mark_".concat((!task.hideGrade).toString()))
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    gradeAndFeedbackDescription = _useState4[0],
    setGradeAndFeedbackDescription = _useState4[1];
  var handleSelectOption = function handleSelectOption(option) {
    if (task && !(task !== null && task !== void 0 && task.isReadOnly)) {
      setSelectedOption(option);
      setIsChanged(true);
      setTask(_objectSpread(_objectSpread({}, task), {}, {
        hideGrade: option.value
      }));
    }
  };
  (0, _react.useEffect)(function () {
    var description = selectedOption !== null && selectedOption !== void 0 && selectedOption.value ? getLabel('text_label_gradeAndFeedbackDescription_feedback') : getLabel('text_label_gradeAndFeedbackDescription_grade');
    setGradeAndFeedbackDescription(description);
  }, [getLabel, selectedOption]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__show-grade-and-feedback'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionLabel.SectionLabel, {
      isDisabled: task === null || task === void 0 ? void 0 : task.isReadOnly,
      text: getLabel('text_label_showScore')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-TaskManager__show-grade-and-feedback-and-description'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        value: selectedOption,
        onChange: handleSelectOption,
        anchorWidth: isMobileView ? 'auto' : 'fit-content',
        btnProps: {
          color: 'basic',
          view: 'outlined',
          customStyle: {
            width: isMobileView ? '100%' : pxToRem(180)
          },
          shape: isMobileView ? 'roundedRectangle' : 'ellipse',
          isDisabled: task === null || task === void 0 ? void 0 : task.isReadOnly
        },
        options: showGradeOptions
      }), gradeAndFeedbackDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionDescription.SectionDescription, {
        text: gradeAndFeedbackDescription
      })]
    })]
  });
};
exports.ShowGradeAndFeedback = ShowGradeAndFeedback;